import { useState } from "react";
import { serviceBrand } from "../../lib/serviceBranding";

/** Cached provider marks are identifiers, not verification or ranking signals. */
export function ServiceLogo({ endpoint, className = "h-11 w-11" }: { endpoint: string; className?: string }) {
  const brand = serviceBrand(endpoint);
  const [failed, setFailed] = useState<string | null>(null);
  return (
    <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-lg bg-paper-deep/60 outline outline-1 outline-black/10 ${className}`} aria-hidden="true">
      {brand.logo && failed !== brand.logo
        ? <img src={brand.logo} alt="" width={44} height={44} loading="lazy" decoding="async" className="h-full w-full object-contain p-1.5" onError={() => setFailed(brand.logo)} />
        : <span className="font-display text-sm font-semibold text-olive-deep">{brand.name.slice(0, 2).toUpperCase()}</span>}
    </span>
  );
}

export function ServiceBrand({ endpoint, compact = false }: { endpoint: string; compact?: boolean }) {
  const brand = serviceBrand(endpoint);
  return (
    <span className="inline-flex min-w-0 items-center gap-2.5">
      <ServiceLogo endpoint={endpoint} className={compact ? "h-7 w-7" : "h-11 w-11"} />
      <span className="min-w-0">
        <span className={`block truncate font-semibold text-ink ${compact ? "text-xs" : "text-sm"}`}>{brand.name}</span>
        {!compact && <span className="block truncate text-xs text-muted">{brand.host}</span>}
      </span>
    </span>
  );
}
